import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12","key":"svg-0"}],["path",{"d":"M4 12l16 0","key":"svg-1"}],["path",{"d":"M12 4l0 16","key":"svg-2"}]]

const IconBorderAll = createReactComponent('outline', 'border-all', 'BorderAll', __iconNode);

export default IconBorderAll;